/**
 * Wrapper for DayPickerSingleDateController for consistent styling of month
 * navigation buttons
 */

import React from 'react';
import { DayPickerSingleDateController as ReactDayPickerSingleDateController } from 'react-dates';

import { PreviousMonthButton, NextMonthButton } from './CustomMonthNavigationButtons';

export default class DayPickerSingleDateController extends React.PureComponent {
    render() {
        return (
            <ReactDayPickerSingleDateController
                {...this.props}
                hideKeyboardShortcutsPanel
                noBorder
                navPrev={<PreviousMonthButton />}
                navNext={<NextMonthButton />} />
        );
    }
}